import React, { useRef } from "react";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

interface Props {
  open: boolean;
  image: string;
  onClose: () => void;
  onCropComplete: (cropped: File) => void;
}

const CropperComponent: React.FC<Props> = ({ open, image, onClose, onCropComplete }) => {
  const cropperRef = useRef<HTMLImageElement>(null);

  const handleCrop = () => {
    const cropper = (cropperRef.current as any)?.cropper;
    if (cropper) {
      cropper.getCroppedCanvas().toBlob((blob: Blob | null) => {
        if (blob) {
          const file = new File([blob], "cropped.jpg", { type: "image/jpeg" });
          onCropComplete(file);
          onClose();
        }
      }, "image/jpeg");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Crop Image</DialogTitle>
      <DialogContent>
        <Cropper
          src={image}
          style={{ height: 400, width: "100%" }}
          initialAspectRatio={NaN} // Free crop
          viewMode={1}
          guides={true}
          dragMode="move"
          cropBoxResizable={true}
          cropBoxMovable={true}
          background={false}
          responsive={true}
          checkOrientation={false}
          ref={cropperRef} // This is enough to access .cropper
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleCrop} variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CropperComponent;
